<div class="notification-card" [ngClass]="notificationSeverity">
  <div class="notification-content" [innerHTML]="notificationHtml"></div>
  @if (notification?.has_progress) {
    <div class="notification-progress">
      <div
        class="progress-bar"
        [style.width]="notification?.overall_progress_percent + '%'"
      ></div>
      <div class="progress-counter">
        {{ notification?.overall_progress_percent }}%
      </div>
    </div>
  }
  <div class="notification-footer">
    <span class="publish-time">{{ notification?.publish_time?.relative }}</span>
    @if (!notification?.is_read) {
      <span class="status">New</span>
    }
  </div>
</div>
